import ViewBase from '../../view-base.view';
import aiJpoModel from '../../../models/schedule/ai-jpo.model';
import languageModel from '../../../models/language.model';
import InfoTabView from './info-tab.view';
import ShopListTabView from './shop-list-tab.view';
import SummaryTabView from './summary-tab.view';
import DetailsTabView from './details-tab.view';
import MapTabView from './map-tab.view';
import ShopReportTabView from './shop-report-tab.view';
import 'CssFolder/schedule/jpo/ai-jpo.scss';

export default function AIJPOView() {
    ViewBase.call(this);

    let activeTab = 'info';

    const TABS = [
        { id: 'info', name: languageModel.getText('', 'Info') },
        { id: 'shoplist', name: languageModel.getText('', 'Shop List') },
        { id: 'summary', name: languageModel.getText('', 'Summary') },
        { id: 'details', name: languageModel.getText('', 'Details') },
        { id: 'map', name: languageModel.getText('', 'Map') },
        { id: 'shopreport', name: languageModel.getText('', 'Shop Processing Report') },
    ];

    let selectTab = (e) => {
        activeTab = e.target.dataset.id;
    };

    // Shared filter state
    let filter = {
        countryCode: 'TH',
        bu: 'CE',
        month: '',
    };

    let setDefaultValue = () => {
        const now = new Date();
        const y = now.getFullYear();
        const m = String(now.getMonth() + 1).padStart(2, '0');
        filter.month = `${y}-${m}`;
    };

    let searchState = { version: 0 };

    let onSearch = () => {
        searchState.version++;
    };

    return {
        oninit: () => {
            setDefaultValue();
        },
        view: () => {
            return [
                m('.ai-jpo',
                    // Search filter bar
                    m('.card.mb-3',
                        m('.card-body',
                            m('.row.g-4',
                                m('.col-sm-6.col-lg-3',
                                    m('label.form-label', languageModel.getText('', 'Month')),
                                    m('input.form-control.form-control-bg', {
                                        type: 'month',
                                        value: filter.month,
                                        onchange: (e) => { filter.month = e.target.value; }
                                    })
                                ),
                                m('.col-sm-6.col-lg-3',
                                    m('label.form-label', languageModel.getText('', 'Country')),
                                    m('select.form-control.form-control-bg', {
                                        value: filter.countryCode,
                                        onchange: (e) => { filter.countryCode = e.target.value; }
                                    }, [
                                        m('option', { value: 'TH' }, 'Thailand'),
                                        m('option', { value: 'VN' }, 'Vietnam'),
                                        m('option', { value: 'ID' }, 'Indonesia'),
                                        m('option', { value: 'MY' }, 'Malaysia'),
                                        m('option', { value: 'PH' }, 'Philippines'),
                                        m('option', { value: 'SG' }, 'Singapore'),
                                    ])
                                ),
                                m('.col-sm-6.col-lg-3',
                                    m('label.form-label', languageModel.getText('', 'BU')),
                                    m('select.form-control.form-control-bg', {
                                        value: filter.bu,
                                        onchange: (e) => { filter.bu = e.target.value; }
                                    }, [
                                        m('option', { value: 'CE' }, 'CE'),
                                        m('option', { value: 'MX' }, 'MX'),
                                    ])
                                ),
                                m('.col-sm-6.col-lg-3.d-flex.align-items-end.gap-2',
                                    m('button.btn.btn-primary', { onclick: onSearch }, languageModel.getText('', 'Search')),
                                )
                            )
                        )
                    ),

                    // Tab navigation
                    m('div', {
                        class: 'cards no-leftradius',
                        style: { marginBottom: '1rem' }
                    },
                        m('div', {
                            class: 'list-group list-group-horizontal',
                            id: 'ai-jpo-tab',
                            role: 'tablist',
                            style: { maxWidth: '900px' }
                        },
                            TABS.map(tab =>
                                m('a.list-group-item.list-group-item-action.text-center', {
                                    class: tab.id === activeTab ? ' active' : '',
                                    id: 'ai-jpo-' + tab.id + '-tab',
                                    'data-bs-toggle': 'list',
                                    role: 'tab',
                                    href: '#ai-jpo-' + tab.id,
                                    'aria-controls': 'ai-jpo-' + tab.id,
                                    'data-id': tab.id,
                                    onclick: selectTab
                                }, tab.name)
                            )
                        )
                    ),

                    // Tab content
                    m('#nav-tabContent.tab-content',
                        m('#ai-jpo-info.tab-pane.fade.show.active', {
                            role: 'tabpanel',
                            'aria-labelledby': 'ai-jpo-info-tab'
                        },
                            m(InfoTabView, { filter: filter, searchVersion: searchState.version })
                        ),
                        m('#ai-jpo-shoplist.tab-pane.fade', {
                            role: 'tabpanel',
                            'aria-labelledby': 'ai-jpo-shoplist-tab'
                        },
                            m(ShopListTabView, { filter: filter, searchVersion: searchState.version })
                        ),
                        m('#ai-jpo-summary.tab-pane.fade', {
                            role: 'tabpanel',
                            'aria-labelledby': 'ai-jpo-summary-tab'
                        },
                            m(SummaryTabView, { filter: filter, searchVersion: searchState.version })
                        ),
                        m('#ai-jpo-details.tab-pane.fade', {
                            role: 'tabpanel',
                            'aria-labelledby': 'ai-jpo-details-tab'
                        },
                            m(DetailsTabView, { filter: filter, searchVersion: searchState.version })
                        ),
                        m('#ai-jpo-map.tab-pane.fade', {
                            role: 'tabpanel',
                            'aria-labelledby': 'ai-jpo-map-tab'
                        },
                            m(MapTabView, { filter: filter, searchVersion: searchState.version })
                        ),
                        m('#ai-jpo-shopreport.tab-pane.fade', {
                            role: 'tabpanel',
                            'aria-labelledby': 'ai-jpo-shopreport-tab'
                        },
                            m(ShopReportTabView, { filter: filter, searchVersion: searchState.version })
                        )
                    )
                ),
                this.getBaseViews()
            ];
        }
    };
}
